import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import { useCustomers } from '../../../hooks/useCustomers';
import { getCurrentCompanyId } from '../../../utils/auth';

const InvoiceFilters = ({ 
  searchTerm, 
  setSearchTerm, 
  statusFilter, 
  setStatusFilter,
  dateRange,
  setDateRange,
  customerFilter,
  setCustomerFilter,
  onReset,
  totalResults 
}) => {
  // Get real customer data from API
  const companyId = getCurrentCompanyId();
  const { data: customers = [] } = useCustomers(companyId);

  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'draft', label: 'Draft' },
    { value: 'sent', label: 'Sent' },
    { value: 'paid', label: 'Paid' },
    { value: 'overdue', label: 'Overdue' },
    { value: 'cancelled', label: 'Cancelled' }
  ];

  // Convert customers to filter options
  const customerOptions = [
    { value: 'all', label: 'All Customers' },
    ...customers.map(customer => ({
      value: customer.id,
      label: customer.customerName || customer.companyName
    }))
  ];

  const dateRangeOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
    { value: 'quarter', label: 'This Quarter' },
    { value: 'year', label: 'This Year' },
    { value: 'custom', label: 'Custom Range' }
  ];

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-4 md:p-6 mb-4 md:mb-6">
      <div className="flex flex-col lg:flex-row lg:items-end gap-4">
        <div className="flex-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="relative">
            <Input
              type="search"
              placeholder="Search invoices..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e?.target?.value)}
              className="pl-10"
            />
            <Icon 
              name="Search" 
              size={18} 
              className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none"
            />
          </div>

          <Select
            options={statusOptions}
            value={statusFilter}
            onChange={setStatusFilter}
            placeholder="Filter by status"
          />

          <Select
            options={customerOptions}
            value={customerFilter}
            onChange={setCustomerFilter}
            placeholder="Filter by customer"
            searchable
          />

          <Select
            options={dateRangeOptions}
            value={dateRange}
            onChange={setDateRange}
            placeholder="Select date range"
          />
        </div>

        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            onClick={onReset}
            iconName="RotateCcw"
            iconPosition="left"
            size="default"
          >
            Reset
          </Button>
          <div className="caption text-muted-foreground whitespace-nowrap">
            {totalResults} {totalResults === 1 ? 'result' : 'results'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceFilters;